// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-footer .colophon[data-v-ea14354e] {\n    background-color: #00435e;\n}\n", ""]);
// Exports
module.exports = exports;
